/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Button } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {
  createNewPlanToStore,
  dispatchContactDetailsPlan,
  dispatchExistingContactDetailsPlan,
  setPlanTabData,
  setReduxDataSearchScreen,
} from '../store/actions';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { redirectURLLink } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  checkActionAccessByRole,
  isReadOnly as readOnly,
} from '../../../../SharedModules/utilities/utilities';

const PlanSearchCriteria = (props) => {
  const { setSelectedPlan, selectedPlan } = props;
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const dispatch = useDispatch();
  const generalSystemParameterDetails = useSelector(
    (state) =>
      state?.sharedState?.SystemProviderReducer?.generalSystemParameter
        ?.paramGeneralVO
  );
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  const reduxDataSearchScreen = useSelector(
    (state) => state?.sharedState?.PlanReducer?.searchScreenData
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly =
      readOnly(window.location.pathname, loginState)?.readOnly || false;
  }
  const [hasAccessbyRole, setHasAccessbyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccessbyRole(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  const handleOnChage = (e) => {
    const value = e?.target?.value;
    setSelectedPlan(value);
    dispatch(
      setReduxDataSearchScreen({
        ...reduxDataSearchScreen,
        state: { selectPlan: value },
      })
    );
  };
  const createNewPlanToStoreHanler = (value) =>
    dispatch(createNewPlanToStore(value));
  const createNewPlan = () => {
    const newDate = [
      {
        newRecord: true,
        cg_id: null,
        cgpId: {
          clientId: '',
          groupId: '',
          planId: '',
          startDt: null,
        },
        index: 0,
        endDt: null,
        planName: '',
        rebateProgramCd: '',
        ltcPlanInd: 0,
        excludeSuppInd: 0,
        lastUpdateDt: '',
        lastUpdateUserId: '',
        corrLinkId: null,
        clientName: '',
        groupName: '',
        startDt: null,
      },
    ];
    createNewPlanToStoreHanler(newDate);
    dispatch(dispatchContactDetailsPlan([]));
    dispatch(dispatchExistingContactDetailsPlan([]));
    window.localStorage.setItem('planSearchOrAdd', 'add');
    dispatch(setPlanTabData({ disabledSaveCancelBtn: true, tabValue: 'one' }));
    redirectURLLink('/createNewPlan', 'Maintain Plan', props.history, dispatch);
    dispatch(
      setReduxDataSearchScreen({
        ...reduxDataSearchScreen,
        currentIndex: null,
      })
    );
  };

  return (
    <div className="no-margin" style={{ width: '99%' }}>
      <div className="form-wrapper">
        <div className="mui-custom-form no-margin override-width-38">
          <fieldset className="custom-fieldset" style={{ width: '50%' }}>
            <legend className="same-font-family">Search Criteria</legend>

            <div className="form-wrapper db">
              <div
                className="sub-radio no-margin"
                id="demo-row-radio-buttons-group-label"
              >
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue={selectedPlan}
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          value="R"
                          onChange={(e) => {
                            handleOnChage(e);
                          }}
                        />
                      }
                      label="Rebate Program Code"
                      data-test="rebate-program-code"
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          value="P"
                          onChange={(e) => {
                            handleOnChage(e);
                          }}
                        />
                      }
                      label="Plan"
                      data-test="super-client"
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          value="C"
                          onChange={(e) => {
                            handleOnChage(e);
                          }}
                        />
                      }
                      label="Client"
                      data-test="client"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
          </fieldset>
        </div>
        <div
          className="float-right  hide-on-print"
          style={{ marginBottom: '10px', marginTop: '0.75rem' }}
        >
          {generalSystemParameterDetails?.[0]?.allowNewCgpInd == 1 && (
            <Button
              className="btn-success same-font-family"
              onClick={createNewPlan}
              disabled={isReadOnly || !isEnablebyRole}
            >
              <SVGComponent iconName="Create-new-icon" />
              {'  '} Create New Plan
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(PlanSearchCriteria);
